const API_BASE_PATH = '/icbc-verification'

const ICBC_VERIFICATION = {
  DATE: `${API_BASE_PATH}/date`,
  UPLOAD: `${API_BASE_PATH}/upload`,
  CHUNK_UPLOAD: `${API_BASE_PATH}/chunk_upload`,
  PROGRESS: `${API_BASE_PATH}/progress`
}

export default ICBC_VERIFICATION
